import {Component, OnInit} from '@angular/core';
import {UserService, MessagesServices} from '../../api/';
import {User} from '../../../models';
import {ToastyService, ToastOptions} from 'ng2-toasty';
import {EditScreenNameDialog, UploadPictureDialog} from '../../dashboard/';
import {Globals} from '../../app.globals';
import {MdDialog, MdDialogRef} from '@angular/material';

@Component({
    selector: 'app-profile',
    templateUrl: './profile.component.html',
    styleUrls: ['./profile.component.css']
})
export class ProfileComponent implements OnInit {
    private editScreenNamedialogRef: MdDialogRef<EditScreenNameDialog>;
    private uploadAvatarDialogRef: MdDialogRef<UploadPictureDialog>;
    private user: User;
    private data: any;
    private loading: boolean = true;
    private activePackages = [];
    private messages: any = new Array<any>();
    msg1: any = '';
    title1: any = '';
    msg2: any = '';
    title2: any = '';
    checkIfMobile: boolean = false;
    public onlineOffline1: boolean = navigator.onLine;

    constructor(private userService: UserService, private sm: MessagesServices, private toastyService: ToastyService, public dialog: MdDialog) {
        //getting messages from db
        window.addEventListener('online', () => {this.onlineOffline1 = true; });
        window.addEventListener('offline', () => {this.onlineOffline1 = false});
        this.messages = this.sm.messags;
        this.setMessages();
    }

    /**
     * setting system messages
     **/
    setMessages() {
        this.msg1 = '';
        this.title1 = '';
        if (this.messages) {
            for (var i = 0; i < this.messages.length; i++) {
                if (this.messages[i].event == 'WG_EVENT_VISIBILITY_IN_SEARCH_RESULTS_UPDATED') {
                    this.title1 = this.messages[i].title;
                    this.msg1 = this.messages[i].message;
                }
                if (this.messages[i].event == 'WG_EVENT_USER_BIO_UPDATED') {
                    this.title2 = this.messages[i].title;
                    this.msg2 = this.messages[i].message;
                }
            }
        }
    }

    ngOnInit() {
        if(this.onlineOffline1){
        this.userService.getUserBasicInfo().subscribe((res) => {
            this.user = res;
            this.data = this.user.avatar;
            this.loading = false;
        });
        this.userService.getMyActivePackages({page: 1}).subscribe((res) => {
            this.activePackages = res;
        });
        }else {
            this.loading = false;
        }
        if (screen.width <= 667) {
            this.checkIfMobile = true;
        }
    }

    changeSearchableStatus($event) {
        this.userService.updateSearchable($event.checked).subscribe((res) => {
            let toastOptions: ToastOptions = {
                title: this.title1,
                msg: this.msg1,
                showClose: true,
                timeout: 2000,
                theme: 'default'
            };
            this.toastyService.success(toastOptions);
        });
    }

    editScreenName() {
        this.editScreenNamedialogRef = this.dialog.open(EditScreenNameDialog, {
            disableClose: false,
            width: '600px'
        });
        this.editScreenNamedialogRef.afterClosed().subscribe(result => {
            this.userService.getUserBasicInfo().subscribe((res) => {
                this.user = res;
                this.data = this.user.avatar;
            });
            this.editScreenNamedialogRef = null;
        });
    }

    openUploadDialog() {
        var width;
        if (screen.width < 361){
             width = '80%';
        }else{
        width = '800px';
        }
        this.uploadAvatarDialogRef = this.dialog.open(UploadPictureDialog, {
            disableClose: false,
            width: width
        });
        this.uploadAvatarDialogRef.afterClosed().subscribe(result => {
            this.userService.getUserBasicInfo().subscribe((res) => {
                this.user = res;
                this.data = this.user.avatar;
                this.userService.getUserEventEmitter().emit({name: 'avatar:changed', data: this.user.screenname});
            });
            this.uploadAvatarDialogRef = null;
        });
    }

    saveChanges(event) {
        this.user.bio = event.value;
        if (event.save === false) {
            return;
        }
        this.userService.updateUserBio(this.user.bio).subscribe((res) => {
            let toastOptions: ToastOptions = {
                title: this.title2,
                msg: this.msg2,
                showClose: true,
                timeout: 2000,
                theme: 'default'
            };
            this.toastyService.success(toastOptions);
        });
    }

}



// WEBPACK FOOTER //
// ./src/app/user/profile/profile.component.ts